import { render, staticRenderFns } from "./DiscoveryProcessStep2.vue?vue&type=template&id=7d036446&scoped=true&"
import script from "./DiscoveryProcessStep2.vue?vue&type=script&lang=js&"
export * from "./DiscoveryProcessStep2.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryProcessStep2.vue?vue&type=style&index=0&id=7d036446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d036446",
  null
  
)

export default component.exports